module.exports = __webpack_public_path__ + "static/media/externalLink.ec73f0db.svg";